import DOMPurify from "dompurify";

// Rewrite any absolute backend URLs baked into module content so they always
// resolve against the CURRENT environment's backend. Without this, an image
// uploaded on preview (whose absolute URL got saved into the artifact HTML)
// breaks when the same module is viewed on production (or vice-versa).
// Also absolutizes bare `/api/media|static/...` paths so srcDoc-loaded iframes
// can resolve them (relative URLs don't resolve sensibly under `about:srcdoc`).
function rewriteBackendUrls(html) {
  if (!html) return html;
  const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (!backend) return html;
  let out = html;
  out = out.replace(
    /https?:\/\/[a-zA-Z0-9-]+(?:\.preview\.emergentagent\.com|\.emergent\.host)(\/api\/(?:media|static)\/[A-Za-z0-9._-]+)/g,
    backend + "$1",
  );
  out = out.replace(
    /(\b(?:src|href)\s*=\s*["'])(\/api\/(?:media|static)\/[A-Za-z0-9._-]+)/g,
    `$1${backend}$2`,
  );
  return out;
}

// Sanitizer for "prose" artifact HTML rendered directly into the page
// (artifact_type === "html" and markdown-converted content).
//
// NOTE: full interactive "embed" artifacts are NOT passed through this —
// they render inside sandboxed <iframe srcDoc> (ArtifactIframe), which is
// the security boundary for script-bearing module content.
export function sanitizeProseHtml(html) {
  return DOMPurify.sanitize(rewriteBackendUrls(html || ""), { ADD_ATTR: ["target"] });
}
